import { Fragment, ReactElement, useMemo } from 'react';
import { ResearchNotificationsCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { ResearchNotificationsSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { ResearchNotificationsMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { ResearchNotificationsCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { ResearchNotificationsCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import ResearchNotificationsShared from 'shell/components/shared/research-notifications/list';

interface ResearchNotificationsCivilStatusRegistryOfficeSharedProps {
  scope?: string;
}

const ResearchNotificationsCivilStatusRegistryOfficeShared = ({
  scope,
}: ResearchNotificationsCivilStatusRegistryOfficeSharedProps): ReactElement => {
  const params = useParams();
  const idCatParams = params.idCat || undefined;

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCatParams);
  }, [scope, idCatParams]);

  const items = useMemo(() => {
    if (idCatParams) {
      return ResearchNotificationsCivilStatusCrumbs(idCatParams);
    }

    if (!scope) {
      return ResearchNotificationsCrumbs;
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return ResearchNotificationsSubscriptionCrumbs;
      case IdAmbito.Mutazioni:
        return ResearchNotificationsMutationCrumbs;
      case IdAmbito.Cancellazioni:
        return ResearchNotificationsCancellationsCrumbs;
      default:
        return [];
    }
  }, [scope, idCatParams]);

  return (
    <Fragment>
      <ResearchNotificationsShared
        scope={scope}
        items={items}
        baseUrl={baseUrl}
        endpointParams={{ idEvent: '1' }}
      />
    </Fragment>
  );
};

ResearchNotificationsCivilStatusRegistryOfficeShared.displayName =
  'Research Notifications Civil Status Registry Office Shared component';

export default ResearchNotificationsCivilStatusRegistryOfficeShared;
